import {
  STORAGETYPE,
} from '../actions/constants';

const initialState = {
  handling: false,
  data: {},
};

export default function StorageType(state = initialState, action) {
  switch (action.type) {
    case STORAGETYPE.handlers.fetch:
    case STORAGETYPE.handlers.update:
    case STORAGETYPE.handlers.import:
    case STORAGETYPE.handlers.remove:
      return {
        ...state,
        handling: true,
      };
    case STORAGETYPE.update:
      return {
        ...state,
        data: action.merge ? {
          ...state.data,
          ...action.data,
        } : action.data,
        handling: false,
      };
    default:
      return state;
  }
}
